import { useGetMunicipalities } from '@features/locations/hooks/useMunicipalities';
import { useGetDepartments } from '@features/locations/hooks/useDepartments';
import { EMPTY_DISPLAY_VALUE } from '@shared/constants/display';
import { formatRuleValue } from '../Utils/formatRuleValue';

const FIELD_CODE_MUNICIPALITY = 'vehicle.circulation_municipality_code';
const FIELD_CODE_DEPARTMENT = 'vehicle.circulation_department_code';

const getNamesByCodes = (codes, results, isFetching) => {
  if (isFetching) return '…';
  if (!codes.length) return EMPTY_DISPLAY_VALUE;
  const items = results ?? [];
  const names = codes.map((code) => items.find((r) => r.code === code)?.name ?? EMPTY_DISPLAY_VALUE);
  return names.join(', ');
};

export const RuleValueDisplay = ({ rule }) => {
  const fieldCode = rule.field?.code;
  const value = rule.value;
  const valueType = rule.field?.fieldType;
  const codes = Array.isArray(value) ? value : value != null ? [value] : [];

  const departmentsQuery = useGetDepartments(
    { codes },
    { enabled: fieldCode === FIELD_CODE_DEPARTMENT && codes.length > 0 }
  );
  const municipalitiesQuery = useGetMunicipalities(
    { codes },
    { enabled: fieldCode === FIELD_CODE_MUNICIPALITY && codes.length > 0 }
  );

  if (fieldCode === 'vehicle.brand') {
    return <>{formatRuleValue(value, valueType || 'string')}</>;
  }
  if (fieldCode === FIELD_CODE_DEPARTMENT) {
    return (
      <>
        {getNamesByCodes(
          codes,
          departmentsQuery.data?.results,
          departmentsQuery.isFetching
        )}
      </>
    );
  }
  if (fieldCode === FIELD_CODE_MUNICIPALITY) {
    return (
      <>
        {getNamesByCodes(
          codes,
          municipalitiesQuery.data?.results,
          municipalitiesQuery.isFetching
        )}
      </>
    );
  }
  return <>{formatRuleValue(value, valueType)}</>;
};
